<template>
  <div class="col-xs-12">

        <div class="col-xs-12">
          <h3 class="font-w200 push-10">{{labelResultFilter[actualLanguage]}}</h3>

          
          <div v-for="(columnTitle, index) in this.tableTitle">

            <div class="form-group">
              <div class="col-sm-3">
                <label>{{ columnTitle[actualLanguage] }}</label>
                    <select class="form-control" v-model=filterSelectedOption[index] id="example-multiple-select" name="example-multiple-select" size="4" multiple>
                        <option value="None">{{labelNone[actualLanguage]}}</option>
                        <option v-for="filterOption in filterOptionList[index]" :value="filterOption">{{ filterOption }}</option>
                    </select>
                <p><button @click="applyFilter2(index)" type="button" class="btn btn-success" name="button">{{labelApplyFilter[actualLanguage]}}</button></p>
                </div>
                
            </div>
            
          </div>

          <div class="col-xs-12">
            <p><button @click="clearFilter()" type="button" class="btn btn-success" name="button">{{labelResetFilter[actualLanguage]}}</button></p>
          </div>
        </div>

        <div class="col-xs-12">
          <h3 class="font-w200 push-10">{{resultsCount}} {{labelResults[actualLanguage]}}</h3>
        </div>

        <div v-if="flagDisplayHistogramSection" class="form-group">
          <div class="col-sm-12 col-md-12">

            <h3 class="font-w200 push-10">{{labelHistogramTitle[actualLanguage]}}</h3>
              <label class="css-input switch switch-success">
                  <input type="checkbox" checked v-model="flagDisplayHistogram"><span></span>{{labelHistogramActivate[actualLanguage]}}
              </label>

            <div v-if="flagDisplayHistogram">
              <div class="block-header">
                <h3 class="block-title">{{labelHistogramPerHour[actualLanguage]}}</h3>
              </div>
              <div class="block-content block-content-full bg-gray-lighter text-center">
                <!-- <monthly-fee-chart :charges="charges"></monthly-fee-chart> -->
                <bar-chart  :chartData="histogramData" ></bar-chart>
              </div>

              <div class="block-header">
                <h3 class="block-title">{{labelHistogramPerDay[actualLanguage]}}</h3>
              </div>
              <div class="block-content block-content-full bg-gray-lighter text-center">
                <!-- <monthly-fee-chart :charges="charges"></monthly-fee-chart> -->
                <bar-chart  :chartData="histogramDataDay" ></bar-chart>
              </div>


            </div>
          </div>
        </div>


        <div class="form-group">


        <div class="col-xs-12">
          <div class="table-responsive">
          <table class="table remove-margin-b font-s13">
            <thead>
              <tr>
                <th v-for="columnTitle in this.tableTitle">{{ columnTitle[actualLanguage] }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="dataLine in this.tableData2">
                <!-- END Footer -->
                <!-- <td v-for="data in dataLine" class="font-w600 text-muted" style="font-size:1.5vw;">{{ data }}</td>-->
                <td v-for="data in dataLine" class="font-w600 text-muted">{{ data }}</td>
              </tr>
            </tbody>
          </table>
          </div>

        </div>
        </div>
  </div>

</template>

<script>

import _ from 'underscore'
import BarChart from '@/components/BarChart.js'

export default {
  props: ['tableDataObj'],
  data() {
    return {

      tableTitle : '',
      tableData : '',
      tableData2 : '',
      dataTempo01 : ['None'],
      filterOptionList : [],
      filterSelectedOption : [],
      resultsCount : 0,
      flagDisplayHistogramSection : false,
      flagDisplayHistogram : true,
      histogramData : null,
      histogramDataDay : null,
      labelResultFilter: {FR: 'Filtre des résultats', EN: 'Results filters'},
      labelHistogramTitle: {FR: 'Histogramme', EN: 'Histogram'}, 
      labelHistogramActivate: {FR: 'Activer', EN: 'Activate'}, 
      labelHistogramPerHour: {FR: 'Histogramme par heure', EN: 'Hour histogram'}, 
      labelHistogramPerDay: {FR: 'Histogramme par jour', EN: 'Daily histogram'},
      labelHistogramDay : {FR : ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'], EN: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']},
      
      labelNone: {FR: 'Aucun', EN: 'None'},
      labelApplyFilter: {FR: 'Filtrer', EN: 'Apply filter'},
      labelResetFilter: {FR: 'Annuler les filtres', EN: 'Reset filters'},
      labelResults: {FR: 'Résultats', EN: 'Results'},
      actualLanguage : "FR",
    }
  },

  components: {
    BarChart,
  },


  methods: {

   clearFilter(){
      this.tableData2 = this.tableData;
      this.resultsCount = this.tableData2.length
      this.constructFilterOptionList()
      this.constructHistogramData()
    },

   applyFilter(){
      
      this.tableData2 = this.tableData.filter(function (e) {
          return e[1] == ['Allo','Bebe'];
      });
      this.resultsCount = this.tableData2.length
    },

   applyFilter2(index){
     //let strToFind = ['Allo','Chien']
     let strToFind = this.filterSelectedOption[index]

      this.tableData2 = [];
      for (let i = 0; i < this.tableData.length; i++) {
          for (let j = 0; j < strToFind.length;j++){
                if (this.tableData[i][index]==strToFind[j]) {
                  this.tableData2.push(this.tableData[i]);
                }
          }
      }
      this.resultsCount = this.tableData2.length
      this.constructFilterOptionList()
      this.constructHistogramData()


    },

   constructFilterOptionList(){

      this.filterOptionList = [];
      this.filterSelectedOption = [];
      for (let i = 0; i < this.tableTitle.length; i++) {
        this.filterOptionList.push([]);
        this.filterSelectedOption.push(['None'])

      }

      for (let i = 0; i < this.tableTitle.length; i++) {
          for (let j = 0; j < this.tableData2.length;j++){
              let optionNotFound = true;
              for (let k = 0; k < this.filterOptionList[i].length;k++){
                if (this.tableData2[j][i]==this.filterOptionList[i][k]) {
                  optionNotFound = false
                }
              }
              if (optionNotFound) {
                  this.filterOptionList[i].push(this.tableData2[j][i]);
              }
          }
          this.filterOptionList[i].sort()       
      }


    },

   constructHistogramData(){
     let alertCount = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
     let alertCountDay = [0,0,0,0,0,0,0]

      for (let j = 0; j < this.tableData2.length;j++){
          var str = this.tableData2[j][0]
          var dayOfWeek = new Date(str).getDay();
          //console.log(str)
          //console.log(dayOfWeek)
          alertCount[parseInt(str.substr(11,2))] = alertCount[parseInt(str.substr(11,2))] + 1
          alertCountDay[dayOfWeek] = alertCountDay[dayOfWeek] + 1
         

      }

      //Compute Histogram data
      this.histogramData = {
      labels: ['0:00','1:00','2:00','3:00','4:00','5:00','6:00','7:00','8:00','9:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00'],
      datasets: [{
        // bezierCurve: false,
        label: 'Nombre alerte par heure',
        backgroundColor: 'rgba(70, 195, 123, 0.8)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: alertCount }]
      }


      //Compute Histogram data Days
      this.histogramDataDay = {
      labels: this.labelHistogramDay[this.actualLanguage],
      datasets: [{
        // bezierCurve: false,
        label: 'Nombre alerte par jour',
        backgroundColor: 'rgba(70, 195, 123, 0.8)',
        borderColor: 'rgba(5, 210, 92, .25)',
        pointBackgroundColor: 'rgba(68, 180, 166, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(68, 180, 166, 1)',
        data: alertCountDay }]
      }
    },


  },
  mounted() {

    this.tableTitle=this.tableDataObj.tableTitle
    this.tableData=this.tableDataObj.tableData
    this.flagDisplayHistogramSection = this.tableDataObj.flagDisplayHistogramSection

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    this.tableData2 = this.tableData
    this.resultsCount = this.tableData2.length
    this.constructFilterOptionList()
    this.constructHistogramData()


  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// DynamicDataTable1.vue?310afd70